import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import * as siteActions from '../../../data/actions/siteActions'
import axios from '../../../data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DrawerConfirm from '~/Common-Objects/UI/Drawer/DrawerConfirm'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import FormatNumberFuncs from '../../../Classes/numberFormatFunctions'
import Change from './changeOrg'
import i18n from '~/i18n'

async function getOrgansisation(SubscriberId) {
    const res = await axios.get('/subscriber/' + SubscriberId + '/organisation')
    return res.data.Organisation
}

export default function SubscriberOrganisation({ SubscriberId, reloadSegments = () => {} }) {
    const [loading, setLoading] = useState(true)
    const [org, setOrg] = useState(null)
    const history = useHistory()
    const dispatch = useDispatch()

    useEffect(() => {
        getOrgansisation(SubscriberId).then((o) => {
            setOrg(o)
            setLoading(false)
        })
    }, [SubscriberId])

    const changeOrg = () => {
        const content = (
            <Change
                SubscriberId={SubscriberId}
                onChange={() => {
                    reloadSegments()
                    getOrgansisation(SubscriberId).then((o) => {
                        setOrg(o)
                    })
                    dispatch(siteActions.alterSiteDrawer(false, true, 'right', null))
                }}
                onCancel={() => dispatch(siteActions.alterSiteDrawer(false, true, 'right', null))}
            />
        )
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', content, true, 400))
    }

    const startClear = () => {
        const drawer = (
            <DrawerConfirm
                header={i18n.t('subscribers:subscriber.org.clearHeader')}
                subheader={i18n.t('subscribers:subscriber.org.clearSubHeader')}
                showCancel={true}
                confirm={clear}
                cancel={() => dispatch(siteActions.alterSiteDrawer(false, true, 'right', null))}
            />
        )

        dispatch(siteActions.alterSiteDrawer(true, true, 'right', drawer, true, 400))
    }

    const clear = async () => {
        await axios.put('/subscriber/' + SubscriberId + '/organisation', {
            OrganisationId: null
        })
        reloadSegments()
        getOrgansisation(SubscriberId).then((o) => {
            setOrg(o)
        })
    }

    const viewOrg = () => {
        history.push('/cp/subscribers/organisations/' + org.id)
    }

    return (
        <Paper isLoading={loading} className='mar-b25'>
            <h4 className='mar-b25'>{i18n.t('subscribers:subscriber.org.header')}</h4>
            {!!org && (
                <div className='text-heavy'>
                    {org.name}{' '}
                    <span className='text-grey text-sml'>
                        ({FormatNumberFuncs.formatNumber(org.Subscribers)}{' '}
                        {org.Subscribers == 1
                            ? i18n.t('subscribers:subscriber.org.subscriber')
                            : i18n.t('subscribers:subscriber.org.subscribers')}
                        )
                    </span>
                </div>
            )}
            {!org && !loading && <div>{i18n.t('subscribers:subscriber.org.noOrganisation')}</div>}
            <div className='mar-t20'>
                {!!org && (
                    <Button
                        text={i18n.t('subscribers:subscriber.org.view')}
                        onClick={viewOrg}
                        className='button-primary mar-r10'
                    />
                )}
                <Button
                    text={
                        org ? i18n.t('subscribers:subscriber.org.change') : i18n.t('subscribers:subscriber.org.assign')
                    }
                    onClick={changeOrg}
                    className='mar-r10'
                />
                {!!org && (
                    <Button
                        text={i18n.t('subscribers:subscriber.org.clear')}
                        onClick={startClear}
                        className='button-red'
                    />
                )}
            </div>
        </Paper>
    )
}
